module.exports = "<p-growl [value]=\"msgs\" [sticky]=\"true\"></p-growl>"